var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-grow"},[(_vm.deliveryPoints)?[(_vm.formModel)?_c('point-form',{attrs:{"model":_vm.formModel}}):_c('points-table',{attrs:{"points":_vm.deliveryPoints}})]:_vm._e(),_c('loading',{attrs:{"is-show":_vm.isPending}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }